import type { Map as MapTypes, EventData } from 'mapbox-gl';
import type { Coordinates } from '@lt/api/dist/types/map';

import { CITY_ZOOM } from './constants';

export const getMapFeatureProperties = (e: EventData) => {
  const [feature] = e.features;

  if (!feature) return null;

  return feature.properties;
};

/**
 * Получаем координаты
 * @param e данные с карты
 */
export const getCoordinates = (e: EventData) => {
  const [feature] = e.features;
  const coordinatesData = feature?.properties?.coordinates;

  try {
    return JSON.parse(coordinatesData) as Coordinates;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      `У отеля ${feature?.properties?.id} не заданы координаты`,
      error,
    );
    return null;
  }
};

/**
 * Зумим карту до города
 */
export const zoomToCity = (map: MapTypes, e: EventData) => {
  if (map.getZoom() >= CITY_ZOOM) return;

  const center = getCoordinates(e);

  if (center) {
    map.easeTo({
      center,
      zoom: CITY_ZOOM,
    });
  }
};

/**
 * Центрируем карту по координатам
 */
export const adjustMapPosition = (
  map: MapTypes,
  center: Coordinates | null,
  params?: { offset?: [number, number]; zoom?: number },
) => {
  if (center) {
    map.easeTo({ center, ...params });
  }
};

export const getZoomProps = (mapPosition, mapbox) => {
  if (!mapPosition.zoom && !mapbox) return {};

  const localZoom = mapbox?.getZoom();
  const zoom = localZoom ? [localZoom] : mapPosition.zoom;

  return { zoom };
};
